import { UseQueryResult, useQuery } from '@tanstack/react-query';
import { Campaign } from '@givebutter/types';
import { FetchLiveDisplayCampaignParams, fetchLiveDisplayCampaign } from 'api/livedisplay';

const useLiveDisplayCampaign = ({
  campaignSlug,
}: FetchLiveDisplayCampaignParams): UseQueryResult<Campaign, Error> => {
  return useQuery<Campaign, Error, Campaign>(
    ['campaigns', campaignSlug, 'livedisplay'],
    () => {
      return fetchLiveDisplayCampaign({ campaignSlug });
    },
    {
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      refetchOnReconnect: false,
    },
  );
};

export { useLiveDisplayCampaign };
